var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Novo cliente")]),_c('v-btn',{attrs:{"color":"secondary"},on:{"click":function($event){return _vm.$router.push('/clientes')}}},[_vm._v("Lista")]),_c('CustomerForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }